import React from "react";
import classnames from "classnames";
import "./FormRow.less";
import { ValueOf } from "../../../../../../constants";

export const FormRowFormats = {
    FORTY_SIXTY: "rs-form__row--40-60",
    FIFTY_FIFTY: "rs-form__row--50-50",
    TWENTY_FIVE: "rs-form__row--25-25-25-25",
    THIRTY_THIRTY_THIRTY: "rs-form__row--30-30-30",
} as const;

type FormRowFormat = ValueOf<typeof FormRowFormats>;

interface FormRowProps {
    children: React.ReactNode;
    format?: FormRowFormat;
}

const FormRow: React.FC<FormRowProps> = ({ children, format }) => (
    <div className={classnames("rs-form__row", format)}>{children}</div>
);

export default FormRow;
